/**
 * Dashboard Theme Configuration
 *
 * amCharts 5 dark theme overrides and AG Grid Quartz dark theme,
 * both parameterized from DASHBOARD_TOKENS for visual consistency.
 */

import * as am5 from '@amcharts/amcharts5';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import am5themes_Dark from '@amcharts/amcharts5/themes/Dark';
import { themeQuartz } from 'ag-grid-community';

import { DASHBOARD_TOKENS } from './tokens';

/**
 * Apply the dashboard dark theme (animated + dark + custom overrides) to an amCharts 5 root.
 */
export function applyDashboardTheme(root: am5.Root): void {
  const darkTheme = am5themes_Dark.new(root);
  const animatedTheme = am5themes_Animated.new(root);

  const customTheme = am5.Theme.new(root);
  customTheme.rule('Label').setAll({
    fill: am5.color(DASHBOARD_TOKENS.textSecondary),
    fontSize: DASHBOARD_TOKENS.fontSize,
    fontFamily: DASHBOARD_TOKENS.fontFamily,
  });
  customTheme.rule('Grid').setAll({
    stroke: am5.color(DASHBOARD_TOKENS.borderSubtle),
    strokeOpacity: 0.4,
  });
  customTheme.rule('Tooltip').setAll({
    getFillFromSprite: false,
  });
  customTheme.rule('RoundedRectangle', ['tooltip', 'background']).setAll({
    fill: am5.color(DASHBOARD_TOKENS.bgCard),
    fillOpacity: 0.95,
    strokeOpacity: 0,
  });

  root.setThemes([animatedTheme, darkTheme, customTheme]);
}

/**
 * AG Grid Quartz dark theme parameterized from DASHBOARD_TOKENS.
 */
export const dashboardGridTheme = themeQuartz.withParams({
  backgroundColor: DASHBOARD_TOKENS.bgCard,
  foregroundColor: DASHBOARD_TOKENS.textPrimary,
  borderColor: DASHBOARD_TOKENS.borderDefault,
  headerBackgroundColor: DASHBOARD_TOKENS.bgHeader,
  headerTextColor: DASHBOARD_TOKENS.textSecondary,
  headerFontWeight: 600,
  headerFontSize: 12,
  accentColor: DASHBOARD_TOKENS.blue,
  fontFamily: DASHBOARD_TOKENS.fontFamily,
  fontSize: DASHBOARD_TOKENS.fontSize,
  rowBorder: { color: DASHBOARD_TOKENS.borderSubtle },
  oddRowBackgroundColor: '#111b25',
  spacing: DASHBOARD_TOKENS.spacing,
  borderRadius: 0,
  wrapperBorderRadius: DASHBOARD_TOKENS.cardBorderRadius,
});
